import { render, staticRenderFns } from "./GroupInfoSidebar.vue?vue&type=template&id=1be10a03&scoped=true"
import script from "./GroupInfoSidebar.vue?vue&type=script&lang=js"
export * from "./GroupInfoSidebar.vue?vue&type=script&lang=js"
import style0 from "./GroupInfoSidebar.vue?vue&type=style&index=0&id=1be10a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be10a03",
  null
  
)

export default component.exports